import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type URL as SchemaURL } from '../schemas/URL';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 */
export const GenerateDigitalOrderYandexPayWidgetURLContentType = '' as const;
export type GenerateDigitalOrderYandexPayWidgetURLRequest = undefined;
export type GenerateDigitalOrderYandexPayWidgetURLResponses = LinkCommonErrorResponses & {
    /**
     * @description Order ready for pay
     */
    '200': {
        'application/json': SchemaURL;
    };
};
export type GenerateDigitalOrderYandexPayWidgetURLResponseSuccess =
    GenerateDigitalOrderYandexPayWidgetURLResponses['200']['application/json'];
export type GenerateDigitalOrderYandexPayWidgetURLSearchParams = {
    on_error_redirect: string;
    on_success_redirect: string;
    on_abort_redirect: string;
    signature: string;
    initial_payment_options: string;
};
export type GenerateDigitalOrderYandexPayWidgetURLPathParameters = {
    store_slug: string;
    order_id: string;
};
export const GenerateDigitalOrderYandexPayWidgetURLUrl =
    '/{store_slug}/digital_orders/{order_id}/yandexpay/widget/url' as const;
export const GenerateDigitalOrderYandexPayWidgetURLMethod = 'GET' as const;
export const getGenerateDigitalOrderYandexPayWidgetURLUrl = (
    params: GenerateDigitalOrderYandexPayWidgetURLPathParameters
) =>
    GenerateDigitalOrderYandexPayWidgetURLUrl.replace(
        /\{(\w+)\}/g,
        (_match, param: keyof GenerateDigitalOrderYandexPayWidgetURLPathParameters) => String(params[param])
    );
